import React from 'react';
import { Scale, Users, Award, TrendingUp } from 'lucide-react';

export const About = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-6">
            <div className="inline-block">
              <span className="text-[#D4AF37] font-semibold text-sm uppercase tracking-wider">About Trademark Liberty</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#0A1F44] leading-tight">
              Safeguarding Innovation. Protecting Identity.
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed">
              At Trademark Liberty, we are dedicated to empowering innovators, entrepreneurs, and businesses with complete intellectual property protection. Our experienced attorneys provide personalized, strategic legal services to safeguard your ideas and brands.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              With extensive experience in intellectual property law, we've helped numerous clients secure their trademarks, copyrights, and patents while building strong legal foundations for their businesses. Our dedicated team provides personalized strategies tailored to your unique needs.
            </p>
          </div>

          {/* Right Content - Value Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div className="bg-gradient-to-br from-[#0A1F44] to-[#153356] p-6 rounded-xl shadow-lg transform hover:scale-105 transition-all duration-300">
              <div className="w-12 h-12 bg-[#D4AF37] rounded-lg flex items-center justify-center mb-4">
                <Scale className="w-6 h-6 text-[#0A1F44]" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2">Legal Excellence</h3>
              <p className="text-gray-300 text-sm">Top-tier legal expertise in all aspects of intellectual property law.</p>
            </div>

            <div className="bg-gradient-to-br from-[#0A1F44] to-[#153356] p-6 rounded-xl shadow-lg transform hover:scale-105 transition-all duration-300">
              <div className="w-12 h-12 bg-[#D4AF37] rounded-lg flex items-center justify-center mb-4">
                <Users className="w-6 h-6 text-[#0A1F44]" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2">Client-Focused</h3>
              <p className="text-gray-300 text-sm">Personalized service tailored to your unique business needs.</p>
            </div>

            <div className="bg-gradient-to-br from-[#0A1F44] to-[#153356] p-6 rounded-xl shadow-lg transform hover:scale-105 transition-all duration-300">
              <div className="w-12 h-12 bg-[#D4AF37] rounded-lg flex items-center justify-center mb-4">
                <Award className="w-6 h-6 text-[#0A1F44]" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2">Proven Results</h3>
              <p className="text-gray-300 text-sm">Consistent track record of successful filings and registrations.</p>
            </div>

            <div className="bg-gradient-to-br from-[#0A1F44] to-[#153356] p-6 rounded-xl shadow-lg transform hover:scale-105 transition-all duration-300">
              <div className="w-12 h-12 bg-[#D4AF37] rounded-lg flex items-center justify-center mb-4">
                <TrendingUp className="w-6 h-6 text-[#0A1F44]" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2">Growth Partners</h3>
              <p className="text-gray-300 text-sm">Supporting your business growth with comprehensive IP strategies.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};